/*
 * This file is part of glowingblue/orell-rezensionen.
 *
 * Copyright (c) 2021 Rafael Horvat.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import { extend } from 'flarum/common/extend';
import DiscussionListState from 'flarum/forum/states/DiscussionListState';
import type { ReviewListRequestParams } from '../types';

/**
 * The review page needs no patch of its own: DiscussionPage sends no `include`, so
 * ShowDiscussionController's defaults (Api\AddArticleIncludes) are what it gets.
 */
export default function () {
	extend(DiscussionListState.prototype, 'requestParams', function (rawParams) {
		const params = rawParams as ReviewListRequestParams;

		params.include.push('review');
		params.include.push('review.article');
		params.include.push('firstPost');
		params.filter = {
			...(params.filter || {}),
			'-isReview': true,
		};
	});
}
